import React from 'react';
import { LooseObj } from '../../custom-types';
import News from '../../components/news/News';
import Members from '../../components/members/Members';
import InvitationNotifierCard from '../../components/invitation-notifier-card/InvitationNotifierCard';
import { ROLE } from '../../app/constants';
import Meeting from '../../components/meeting/Meeting';

interface Props {
  userData: LooseObj;
  tenantData: LooseObj;
  isUserProcessing: boolean;
  isAccountProcessing: boolean;
}

const GuestDashboard: React.FC<Props> = ({
  userData,
  tenantData,
  isUserProcessing,
  isAccountProcessing,
}) => (
  <div>
    <div className="left-col">
      <Meeting />
      <News />
    </div>
    <div className="right-col">
      <InvitationNotifierCard />
      <Members
        activeUserRole={ROLE.GUEST}
        userData={userData}
        tenantData={tenantData}
        isUserProcessing={isUserProcessing}
        isAccountProcessing={isAccountProcessing}
      />
    </div>
  </div>
);

export default GuestDashboard;
